export const AnnounceFilterCleared = "Filter selection cleared";
export const AnnounceFilterResultCount = "Showing {0} filtered items.";
export const AnnounceFinishedLoadingItems = "Finished loading items";
export const AnnounceItemCount = "Showing {0} items.";
export const AnnounceLoadingItems = "Loading items";
export const ClearText = "Clear text";
export const Close = "Close";
export const DropdownCalloutRoleDescription = "Expanded dropdown";
export const DropdownClearActionText = "Clear";
export const DropdownExpandableRoleDescription = "Dropdown";
export const FilterAriaLabel = "{0} filter: {1}";
export const HeaderAriaLabel = "Header {0}";
export const ListboxAriaLabel = "Listbox";
export const Loading = "Loading...";
export const NoFilterResults = "No items matched the supplied filter";
export const NoItemsFound = "No items found";
export const SearchAriaLabel = "Search";
export const Searching = "Searching...";
export const UseItem = "Use \"{0}\"";
